function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 550px;\n  margin: 0 auto;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { Typography } from "antd";
import styled from "styled-components";
var Wrap = styled.div(_templateObject());
var Empty = function(param) {
    var image = param.image, title = param.title, body = param.body;
    return /*#__PURE__*/ React.createElement(Wrap, null, /*#__PURE__*/ React.createElement("img", {
        src: image,
        style: {
            width: 400,
            height: 211,
            alignSelf: "center"
        },
        alt: ""
    }), /*#__PURE__*/ React.createElement(Typography.Title, {
        level: 3
    }, title), /*#__PURE__*/ React.createElement(Typography.Paragraph, null, body));
};
export default Empty;
